import styled, { css } from "styled-components";

import { SectionProps, BoltProps } from "./Section.types";
import { BoltIcon, boltInfo } from "./Section.boltIcon";

export const Bolt = styled(BoltIcon)<BoltProps>`
  --bolt-color: ${({ $color, theme }) => theme.palette[$color]};

  position: absolute;
  bottom: -1px; // workaround to avoid a gap between the bolt and the section
  left: 0;
  width: 100%;
  fill: var(--bolt-color);
  z-index: 0;

  ${props =>
    props.$variant === "left" &&
    css`
      transform: scaleX(-1);
    `}
`;

export const Section = styled.section<SectionProps>`
  color: ${({ $color, theme }) =>
    $color ? theme.palette[$color] : "currentColor"};
  background-color: ${({ $backgroundColor, theme }) =>
    $backgroundColor ? theme.palette[$backgroundColor] : "transparent"};

  ${({ $backgroundImage }) =>
    $backgroundImage &&
    css`
      background-image: ${$backgroundImage};
    `}

  &:has(${Bolt}) {
    position: relative;
    min-height: calc(100vw * ${boltInfo.height} / ${boltInfo.width});
    overflow: hidden;
  }

  ${({ $overflowHidden }) =>
    $overflowHidden &&
    css`
      overflow: hidden;
    `}
`;
